<div class="games-page-container bg-black">
  <div class="container">
    <div class="card bg-secondary">
      <div class="card-header">
        <img [alt]="'games.page.trivia.title' | translate" src="assets/images/games/trivia.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.trivia.title' | translate }}</h3>
        <p>{{ 'games.page.trivia.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/trivia']">{{ 'games.page.trivia.button' | translate }}</a>
      </div>
    </div>

    <div class="card bg-secondary">
      <div class="card-header">
        <img [alt]="'games.page.polls.title' | translate" src="assets/images/games/polls.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.polls.title' | translate }}</h3>
        <p>{{ 'games.page.polls.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/polls']">{{ 'games.page.polls.button' | translate }}</a>
      </div>
    </div>
  </div>
</div>
